module.exports = __webpack_public_path__ + "static/img/ranqi.b2538f83.png";